// Création de l'objet à envoyer au back
const formaterFichierPieceJustificativeMineur = async (dataForm) => {
    return dataForm.pieceJustificativeMineur
        ? dataForm.pieceJustificativeMineur[0].getFileToSend()
        : null;
};

export default formaterFichierPieceJustificativeMineur;
